<div class="lot-container">

    <div fxLayout="row" fxLayoutAlign="start center" style="margin-bottom:18px" class="fz_21 fc_DEDEDE">
        <ng-container *ngIf="!isFiltered">
            Total {{lots.length}} Lots
        </ng-container>
        <ng-container *ngIf="isFiltered">
            {{dataSourceCount}} Result
        </ng-container>
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between" style="margin-bottom:16px" class="box">
        <div fxLayout="row" fxLayoutGap="12px">
            <input (keyup.enter)="filterData()" [(ngModel)]="keywords" class="input search-input" type="text"
                placeholder="Search Lot Number" />
            <button mat-button class="filter-button" [matMenuTriggerFor]="filterMenu"  *ngIf="!isFiltered">
                <img class="png-icon" src="./assets/images/black/filter.png">
                Filter
            </button>
            <button mat-button class="filter-button isFiltered"  *ngIf="isFiltered" [matMenuTriggerFor]="filterMenu">
                <img class="png-icon" src="./assets/images/black/filter.png">
                Filter
            </button>
            <button mat-button class="filter-button" (click)="clearFilterDataSearch()"  *ngIf="isFiltered"  >
                Clear Filter
            </button>
            
     
            <mat-menu #filterMenu="matMenu" xPosition="before" class="filter-menu">
                <div fxLayout="column" (click)="stopPropagation($event)">
                    <div fxLayout="row" fxLayoutAlign="space-between">
                        <div class="fc_DEDEDE">Filter</div>
                        <a class="clear-filter fz_14" (click)="clearFilterData()">Clear Filter</a>
                    </div>

                    <div class="menu-item  ">
                        <div style="width: 100%;">
                            <div class="item-title">Width Range</div>
                            <div class="item-content" fxLayout="row" fxLayoutGap="15px">
                                <mat-form-field appearance="outline">
                                    <mat-label>Min Width</mat-label>
                                    <mat-select [(value)]="filterParams.widthRange.min">
                                        <mat-option  [value]="minWidth">
                                            Any
                                        </mat-option>
                                        <mat-option *ngFor="let item of widthArray" [value]="item">
                                            {{item}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field appearance="outline">
                                    <mat-label>Max Width</mat-label>
                                    <mat-select [(value)]="filterParams.widthRange.max">
                                        <mat-option  [value]="maxWidth">
                                            Any
                                        </mat-option>
                                        <mat-option *ngFor="let item of widthArray" [value]="item">
                                            {{item}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                               
                            </div>
                        </div>
                        <div style="width: 100%;">
                            <div class="item-title">Length Range</div>
                            <div class="item-content" fxLayout="row" fxLayoutGap="15px">
                                <mat-form-field appearance="outline">
                                    <mat-label>Min Length</mat-label>
                                    <mat-select [(value)]="filterParams.lengthRange.min">
                                        <mat-option  [value]="minLength">
                                            Any
                                        </mat-option>
                                        <mat-option *ngFor="let item of lengthArray" [value]="item">
                                            {{item}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field appearance="outline">
                                    <mat-label>Max Length</mat-label>
                                    <mat-select [(value)]="filterParams.lengthRange.max">
                                        <mat-option  [value]="maxLength">
                                            Any
                                        </mat-option>
                                        <mat-option *ngFor="let item of lengthArray" [value]="item">
                                            {{item}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                              
                            </div>
                        </div>

                        <div style="width: 100%;">
                            <div class="item-title">Price Range</div>
                            <div class="item-content" fxLayout="row" fxLayoutGap="15px">
                              
                                <mat-form-field appearance="outline">
                                    <mat-label>min Price</mat-label>
                                    <mat-select [(value)]="filterParams.priceRange.min">
                                        <mat-option  [value]="minPrice">
                                            Any
                                        </mat-option>
                                        <mat-option *ngFor="let item of priceArray" [value]="item.value">
                                            {{item.label}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field appearance="outline">
                                    <mat-label>Max Price</mat-label>
                                    <mat-select [(value)]="filterParams.priceRange.max">
                                        <mat-option  [value]="maxPrice">
                                            Any
                                        </mat-option>
                                        <mat-option *ngFor="let item of priceArray" [value]="item.value">
                                            {{item.label}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                              
                            </div>
                        </div>

                    </div>
                    <!-- <div class="menu-item">
                        <div class="item-title">Width Range</div>
                        <div class="item-content">
                            <mat-range-slider [style.flex-grow]="0" #widthRangeSlider class="price-range"
                                [disabled]="false" [invert]="false" [max]="maxWidth" [min]="minWidth"
                                (input)="filterParams.widthRange = $event.value" [step]="1" [thumbLabel]="false"
                                [tickInterval]="0" [vertical]="false">
                            </mat-range-slider>
                            <div style="display: flex; justify-content: space-between;">
                                <span>{{filterParams.widthRange.min}}</span>
                                <span>{{filterParams.widthRange.max}}</span>
                            </div>
                        </div>
                    </div>

                    <div class="menu-item">
                        <div class="item-title">Length Range</div>
                        <div class="item-content">
                            <mat-range-slider [style.flex-grow]="0" #lengthRangeSlider class="price-range"
                                [disabled]="false" [invert]="false" [max]="maxLength" [min]="minLength"
                                (input)="filterParams.lengthRange = $event.value" [step]="1" [thumbLabel]="false"
                                [tickInterval]="0" [vertical]="false">
                            </mat-range-slider>
                            <div style="display: flex; justify-content: space-between;">
                                <span>{{filterParams.lengthRange.min}}</span>
                                <span>{{filterParams.lengthRange.max}}</span>
                            </div>
                        </div>
                    </div> -->

                    <!-- <div class="menu-item">
                        <div class="item-title">Price Range</div>
                        <div class="item-content">
                            <mat-range-slider [style.flex-grow]="0" #priceRangeSlider class="price-range"
                                [disabled]="false" [invert]="false" [max]="maxPrice" [min]="minPrice"
                                (input)="filterParams.priceRange = $event.value" [step]="1" [thumbLabel]="false"
                                [tickInterval]="0" [vertical]="false">
                            </mat-range-slider>
                            <div style="display: flex; justify-content: space-between;">
                                <span>{{filterParams.priceRange.min}}</span>
                                <span>{{filterParams.priceRange.max}}</span>
                            </div>
                        </div>
                    </div> -->
                    <div class="menu-item">
                        <div class="item-title">Park Front</div>
                        <div class="item-content" fxLayout="row wrap" fxLayoutGap="20px" fxLayoutAlign="start">
                            <mat-checkbox *ngFor="let item of filterParams.parkFront" [(ngModel)]="item.isChecked">
                                {{item.label}}</mat-checkbox>
                        </div>
                    </div>
                    <div class="menu-item">
                        <div class="item-title">Lake Front</div>
                        <div class="item-content" fxLayout="row wrap" fxLayoutGap="20px" fxLayoutAlign="start">
                            <mat-checkbox *ngFor="let item of filterParams.lakeFront" [(ngModel)]="item.isChecked">
                                {{item.label}}</mat-checkbox>
                        </div>
                    </div>
                    <div class="menu-item">
                        <div class="item-title">Corner Block</div>
                        <div class="item-content" fxLayout="row wrap" fxLayoutGap="20px" fxLayoutAlign="start">
                            <mat-checkbox *ngFor="let item of filterParams.cornerBlock" [(ngModel)]="item.isChecked">
                                {{item.label}}</mat-checkbox>
                        </div>
                    </div>
                    <div class="menu-item">
                        <div class="item-title">Status</div>
                        <div class="item-content" fxLayout="row wrap" fxLayoutGap="20px" fxLayoutAlign="start"
                            style="height: 80px;">
                            <mat-checkbox *ngFor="let item of filterParams.status" [(ngModel)]="item.isChecked">
                                {{item.label}}</mat-checkbox>
                        </div>
                    </div>
                    <button (click)="filterData()" mat-flat-button class="search_button mt_20">Search</button>
                </div>
            </mat-menu>
        </div>

        <div fxLayout="row" fxLayoutGap="12px">
            <!-- <button mat-button class="add-lot-button" (click)="openAddDialog()">
                <mat-icon style="margin-bottom: 2px; width: 16px; height: 16px; font-size: 16px; margin-right: 4px">
                    add
                </mat-icon>
                Add lot
            </button> -->

            <div class="switch-button-group ml_20" fxLayout="row" fxLayoutAlign="center center">
                <div class="block_box" fxLayout="row" fxLayoutAlign="center center"
                    [ngClass]="{'active':  mode == 'list'}" (click)="changeMode('list')">
                    <img src="./assets/images/black/list_{{mode}}.png" class="list_image">
                </div>
                <div class="block_box" fxLayout="row" fxLayoutAlign="center center"
                    [ngClass]="{'active':  mode == 'grid'}" (click)="changeMode('grid')">
                    <img src="./assets/images/black/block_{{mode}}.png" class="list_image">
                </div>
            </div>

        </div>
    </div>

    <div fxLayout="row" fxLayoutGap="24px" class="lot-status" style="margin-bottom:24px" *ngIf="mode == 'grid'">
        <app-property-status [status]="0"></app-property-status>
        <app-property-status [status]="1"></app-property-status>
        <app-property-status [status]="3"></app-property-status>
        <app-property-status [status]="4"></app-property-status>
        <app-property-status [status]="6"></app-property-status>
    </div>

    <div fxLayout="row" fxLayoutAlign="space-between" class="lots-content">
        <mat-tab-group mat-align-tabs="start" style="width:100%" (selectedTabChange)="tabChanged($event)" #childTabs>
            <mat-tab *ngFor="let building of this.buildings; let i = index">
                <ng-template mat-tab-label>
                    {{ building.name ? building.name : 'Stage' + (i + 1) }}
                    <span class="tab-count">{{dataSource.get(building.id).data.length}}</span>
                </ng-template>
                <div *ngIf="dataSource.get(building.id).data.length > 0 && mode == 'grid'" class="lot-matrix"
                    [ngStyle]="{'min-height': (windowHeight - 464)+'px'}">

                    <div fxLayout="row wrap" fxLayoutGap="24px" style="margin-bottom: 5px;margin-top: 24px;">
                        <div *ngFor="let lot of dataSource.get(building.id).data; let i = index"
                            class="matrix-box show-on-hover {{getStatusLabel(lot.status)}}"
                            [ngClass]="{'matrix-box-checked': lot.isChecked === true}">
                            <div class="matrix-content" (click)="openDetailDialog(lot, building)">
                                <div class="flex align-center">
                                    <div class="fc_DEDEDE fz_24">
                                        {{lot.lotNumber}}</div>
                                    <div class="ml_15 fz_14  {{getStatusLabel(lot.status)}} flex align-center">
                                        <div class="dot {{getStatusLabel(lot.status)}}BG"></div>
                                        {{getStatusLabel(lot.status) | titlecase}}
                                    </div>
                                </div>

                                <div (click)="openDetailDialog(lot, building)"
                                    style="font-size: 14px;color: rgba(222, 222, 222, 0.4);margin-top: 24px;">
                                    {{lot.width}} W /
                                    {{lot.length}} L</div>
                                <div (click)="openDetailDialog(lot, building)" class="fc_DEDEDE fz_16" style="position: absolute;bottom: 16px;right: 16px;
                                ">{{lot.price |
                                    currency:
                                    '':'symbol':'1.0'}}</div>

                            </div>
                            <mat-checkbox *ngIf="lot.status != 6" [(ngModel)]="lot.isChecked"
                                (change)="selectedLotsChange(building.id)" (click)="stopPropagation($event);"
                                class="show-on-hover"
                                style="position: absolute; top: 5px; right: 5px; width: 16px; height: 16px">
                            </mat-checkbox>
                        </div>
                    </div>
                </div>
                <div class="lots-table" *ngIf="dataSource.get(building.id).data.length > 0 && mode == 'list'"
                    [ngStyle]="{'min-height': (windowHeight - 464)+'px'}">
                    <table mat-table [dataSource]="dataSource.get(building.id).data" style="width: 100%;">
                        <ng-container matColumnDef="select">
                            <th mat-header-cell *matHeaderCellDef>
                                <mat-checkbox [color]="'primary'" (change)="$event ? masterToggle(building.id) : null"
                                    [checked]="dataSource.get(building.id).selection.hasValue() && isAllSelected(building.id)"
                                    [indeterminate]="dataSource.get(building.id).selection.hasValue() && !isAllSelected(building.id)"
                                    [aria-label]="checkboxLabel(building.id)">
                                </mat-checkbox>
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <mat-checkbox *ngIf="row.status != 6" [color]="'primary'" [(ngModel)]="row.isChecked"
                                    (click)="stopPropagation($event);"
                                    (change)="$event ? dataSource.get(building.id).selection.toggle(row) : null"
                                    [checked]="dataSource.get(building.id).selection.isSelected(row)"
                                    (change)="selectedLotsChange(building.id)"
                                    [aria-label]="checkboxLabel(building.id, row)">
                                </mat-checkbox>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="number">
                            <th mat-header-cell *matHeaderCellDef>
                                <div class="lots-table-title">Lot Number</div>
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{element.lotNumber}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="width">
                            <th mat-header-cell *matHeaderCellDef>
                                <div class="lots-table-title">Width m</div>
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{element.width}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="length">
                            <th mat-header-cell *matHeaderCellDef>
                                <div class="lots-table-title">Length m</div>
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{element.length}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="size">
                            <th mat-header-cell *matHeaderCellDef>
                                <div class="lots-table-title">Size m²</div>
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{element.lotSize}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="price">
                            <th mat-header-cell *matHeaderCellDef>
                                <div class="lots-table-title">Price (AUD)</div>
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <span style="cursor: pointer">{{element.price | currency: '':'symbol':'1.0-0'}}</span>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef>
                                <div class="lots-table-title">Status</div>
                            </th>
                            <td mat-cell *matCellDef="let element" style="text-align: left;">
                                <span style="cursor: pointer" style="padding-left: 20px;">
                                    <ng-container *ngIf="element.status === 0">
                                        <span class="status-point" style="background: #B0DDCD"></span>Unavailable
                                    </ng-container>
                                    <ng-container *ngIf="element.status === 1">
                                        <span class="status-point" style="background: #03BC79"></span>Available
                                    </ng-container>
                                    <ng-container *ngIf="element.status === 2 || element.status === 3">
                                        <span class="status-point" style="background: #FFC01D"></span>Reserved
                                    </ng-container>
                                    <ng-container *ngIf="element.status === 4 || element.status ===5">
                                        <span class="status-point" style="background: #2589FE"></span>Processing
                                    </ng-container>
                                    <ng-container *ngIf="element.status === 6">
                                        <span class="status-point" style="background: #B0B0B0"></span>Settle
                                    </ng-container>
                                </span>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="package">
                            <th mat-header-cell *matHeaderCellDef>
                                <div class="lots-table-title">Package</div>
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{element.packageProjects && element.packageProjects.length ? 'Yes' : 'No'}}
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
                        <tr (click)="openDetailDialog(row, building)" mat-row
                            *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                </div>
                <ng-container *ngIf="dataSource.get(building.id).data.length === 0 && !isFiltered">
                    <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; padding: 40px 0;min-height: 300px;"
                        [ngStyle]="{'min-height': (windowHeight - 520)+'px'}">
                        <p style="margin:4px;color: #352942;font-size: 18px;font-weight: 600;">No lot found</p>
                        <p style="margin:4px;color: #352942;opacity: 0.7;">You have not added any lot in this building
                        </p>
                        <button mat-flat-button
                            style="margin-top:12px;background: #161616;border-radius: 4px;color:#dedede"
                            (click)="openAddDialog()">Add Lot</button>
                    </div>
                </ng-container>
                <ng-container *ngIf="dataSource.get(building.id).data.length === 0 && isFiltered">
                    <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; padding: 40px 0;min-height: 300px;"
                        [ngStyle]="{'min-height': (windowHeight - 520)+'px'}">
                        <p style="margin:4px;color: #352942;font-size: 18px;font-weight: 600;">No matching items found
                        </p>
                        <p style="margin:4px;color: #352942;opacity: 0.7;">Try adjusting your search or filter to find
                            what are you looking for.</p>
                    </div>
                </ng-container>
            </mat-tab>

        </mat-tab-group>
    </div>
    <div class="status-bar" fxLayout="row" *ngIf="showStatusBar" fxLayoutAlign="space-between center">
        <div style="font-weight: 500;font-size: 16px;">{{selectedLots.length}} lots selected</div>
        <div fxLayout="row">
            <mat-menu #statusMenu="matMenu" yPosition="above" class="status-menu">
                <button mat-menu-item (click)="openUpdateStatusDialog(0)">
                    <app-property-status [status]="0"></app-property-status>
                </button>
                <button mat-menu-item (click)="openUpdateStatusDialog(1)">
                    <app-property-status [status]="1"></app-property-status>
                </button>
                <button mat-menu-item (click)="openUpdateStatusDialog(3)">
                    <app-property-status [status]="3"></app-property-status>
                </button>
                <button mat-menu-item (click)="openUpdateStatusDialog(4)">
                    <app-property-status [status]="4"></app-property-status>
                </button>
                <button mat-menu-item (click)="openUpdateStatusDialog(6)">
                    <app-property-status [status]="6"></app-property-status>
                </button>
                <div class="target"></div>
            </mat-menu>
            <button mat-flat-button [matMenuTriggerFor]="statusMenu" class="change-status-button">Status</button>
            <button mat-button class="close-button">
                <mat-icon fontSet="material-icons-round" (click)="closeStatusBar()">close</mat-icon>
            </button>
        </div>
    </div>
</div>